// TR IBAN: "TR" + 2 kontrol hanesi + 22 rakam = 26 karakter.
export const TR_IBAN_PREFIX = "TR";
export const TR_IBAN_LENGTH = 26;

// Kullanicinin yazdigini "TR" ile baslayan, sadece rakam iceren bir IBAN'a cevirir.
// Kullanici "TR"yi kendisi yazsa ya da yapistirsa da tekrarlanmaz.
export const normalizeTrIban = (value) => {
  const raw = (value || "").toUpperCase().replace(/[^A-Z0-9]/g, "");
  const digits = raw.replace(/^TR/, "").replace(/\D/g, "");
  return (TR_IBAN_PREFIX + digits).slice(0, TR_IBAN_LENGTH);
};

// Ekranda 4'lu gruplar halinde gosterir: "TR12 3456 ..."
export const formatIban = (value) =>
  (value || "").replace(/\s/g, "").replace(/(.{4})/g, "$1 ").trim();

// ISO 13616 MOD-97 kontrolu.
const mod97 = (iban) => {
  const rearranged = iban.slice(4) + iban.slice(0, 4);
  const numeric = rearranged.replace(/[A-Z]/g, (c) =>
    (c.charCodeAt(0) - 55).toString()
  );
  let remainder = 0;
  for (const ch of numeric) {
    remainder = (remainder * 10 + Number(ch)) % 97;
  }
  return remainder;
};

// react-hook-form validate fonksiyonu: gecerliyse true, degilse hata mesaji.
export const validateTrIban = (value) => {
  const iban = (value || "").replace(/\s/g, "").toUpperCase();
  if (!iban || iban === TR_IBAN_PREFIX) return "Bu alan zorunlu";
  if (!iban.startsWith(TR_IBAN_PREFIX)) return "IBAN TR ile başlamalıdır";
  if (!/^TR\d{24}$/.test(iban)) {
    return `IBAN ${TR_IBAN_LENGTH} karakter olmalıdır (şu an ${iban.length})`;
  }
  if (mod97(iban) !== 1) return "Geçersiz IBAN, lütfen kontrol edin";
  return true;
};
